'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {
      this.loaderBg = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBg');
      this.loaderBar = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBar');
      (0, _utils.centerGameObjects)([this.loaderBg, this.loaderBar]);
      this.load.setPreloadSprite(this.loaderBar);

      this.game.load.atlas("sprites", "assets/images/spritesheet.png", "assets/images/sprites.json");
      this.game.load.audio("music", "assets/sound/water.mp3");
    }
  }, {
    key: 'bigPixels',
    value: function bigPixels(size) {
      game.scale.scaleMode = _phaser2.default.ScaleManager.USER_SCALE;
      game.scale.setUserScale(size, size);

      // enable crisp rendering
      game.renderer.renderSession.roundPixels = true;
      _phaser2.default.Canvas.setImageRenderingCrisp(this.game.canvas);
      _phaser2.default.Canvas.setSmoothingEnabled(this.game.canvas, false);
    }
  }, {
    key: 'create',
    value: function create() {
      this.bigPixels(6);
      this.state.start('Game');
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Splash.js
// module id = 127
// module chunks = 0